"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var report_options_1 = require("../report-options");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Builder for report options
 *
 * Created by Hayk.Andriasyan on 9/11/2017.
 */
var ReportOptionsBuilder = /** @class */ (function () {
    function ReportOptionsBuilder() {
        this._reportOptions = new report_options_1.ReportOptions();
    }
    ReportOptionsBuilder.prototype.fetchNames = function (fetchNames) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(fetchNames);
        this._reportOptions.fetchNames = fetchNames;
        return this;
    };
    ReportOptionsBuilder.prototype.showIndicatorDisaggregations = function (showIndicatorDisaggregations) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(showIndicatorDisaggregations);
        this._reportOptions.showIndicatorDisaggregations = showIndicatorDisaggregations;
        return this;
    };
    ReportOptionsBuilder.prototype.hideUnspecifiedRowHierarchy = function (hideUnspecifiedRowHierarchy) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(hideUnspecifiedRowHierarchy);
        this._reportOptions.hideUnspecifiedRowHierarchy = hideUnspecifiedRowHierarchy;
        return this;
    };
    ReportOptionsBuilder.prototype.outSidePathHolderIds = function (outSidePathHolderIds) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(outSidePathHolderIds);
        this._reportOptions.outSidePathHolderIds = outSidePathHolderIds;
        return this;
    };
    ReportOptionsBuilder.prototype.fetchTotalCount = function (fetchTotalCount) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(fetchTotalCount);
        this._reportOptions.fetchTotalCount = fetchTotalCount;
        return this;
    };
    ReportOptionsBuilder.prototype.fetchLevelIndexes = function (fetchLevelIndexes) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(fetchLevelIndexes);
        this._reportOptions.fetchBranchIndexes = fetchLevelIndexes;
        return this;
    };
    ReportOptionsBuilder.prototype.fetchBranchIndexes = function (fetchBranchIndexes) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(fetchBranchIndexes);
        this._reportOptions.fetchBranchIndexes = fetchBranchIndexes;
        return this;
    };
    ReportOptionsBuilder.prototype.fetchColumnIndexes = function (fetchColumnIndexes) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(fetchColumnIndexes);
        this._reportOptions.fetchColumnIndexes = fetchColumnIndexes;
        return this;
    };
    ReportOptionsBuilder.prototype.needDateFormat = function (needDateFormat) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(needDateFormat);
        this._reportOptions.needDateFormat = needDateFormat;
        return this;
    };
    ReportOptionsBuilder.prototype.needNumberFormat = function (needNumberFormat) {
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(needNumberFormat);
        this._reportOptions.needNumberFormat = needNumberFormat;
        return this;
    };
    ReportOptionsBuilder.prototype.timezoneOffset = function (timezoneOffset) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(timezoneOffset);
        this._reportOptions.timezoneOffset = timezoneOffset;
        return this;
    };
    ReportOptionsBuilder.prototype.build = function () {
        return this._reportOptions;
    };
    return ReportOptionsBuilder;
}());
exports.ReportOptionsBuilder = ReportOptionsBuilder;
//# sourceMappingURL=report-options-builder.js.map